import React from "react";
import { FaBusAlt } from "react-icons/fa";
import "../css/BusRoutes.css";

const BusRoutes = () => {
  const routesData = [
    {
      direction: "West",
      areas: [
        "Jhandanagar",
        "Laxminagar",
        "Ramwapur",
        "Balanagar",
        "Hirdaynagar",
        "Lakhaura",
        "Thakurapur",
        "Mahadev",
        "Srisihawa",
        "Chaipurwa",
        "Patna",
      ],
    },
    {
      direction: "East",
      areas: ["Kukurbhukwa", "Madhrahniya"],
    },
    {
      direction: "North",
      areas: [
        "Chandrauta Highway",
        "Parshuttam Pur",
        "Bhilmi",
        "Karma",
        "Gurchihwa",
        "Gurchihwa Dihwa",
        "Dabara",
        "Dang Highway",
        "Marha",
        "Sarfar",
        "Sonahwa",
        "Amouli",
        "Jhinghha",
      ],
    },
    {
      direction: "South",
      areas: ["Semra", "Gole Ghar", "Nepal–India Border"],
    },
  ];

  return (
    <section className="school-bus-routes-section">
      <div className="bus-routes-container">
        <div className="routes-header-block">
          <h2 className="routes-main-title">
            <FaBusAlt className="header-bus-icon" />
            School Bus Routes
          </h2>

          <p className="routes-sub-description">
            Our school provides safe, reliable, and well-managed transportation
            services across nearby villages and surrounding areas, ensuring a
            comfortable daily commute for students.
          </p>
        </div>

        <div className="capsules-outer-card">
          {routesData.map((routeGroup, index) => (
            <div className="route-direction-block" key={index}>
              <h3 className="route-direction-title">{routeGroup.direction}</h3>

              <div className="capsules-flex-cluster">
                {routeGroup.areas.map((area, i) => (
                  <div key={i} className="route-capsule-item">
                    {area}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusRoutes;
